import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PubSub from 'pubsub-js';

class AppsEmDestaqueItem extends Component {
    constructor(){
        super();

        this.state= {
            lang: 'pt'
        }

        this.locationTexts= {
            "mais-informações" : {"pt" : "Mais Informações", "es": "Más Informaciones", "en": "More Informations"}
        };
    }
    
    urlWhithLang(appId, lang){
        if(lang)
            return `/app/${lang}/${appId}`;
        else
            return `/app/${appId}`;
    }

    componentWillMount(){
        PubSub.subscribe('language.change', (msg, lang) => this.setState({lang}));
    }

    render() {        
        const texts= this.locationTexts;
        //console.log(this.state.lang);
        const app = this.props.app.Contents.filter(app => {return (app.lang === this.state.lang)});
        
        return (            
            <section className="appsEmDestaque-itens">
                <div className="appsEmDestaque-itens-background">
                    <picture>
                        <source media="(max-width: 600px)" srcSet={app[0].squareBanner} />
                        <img src={app[0].wideBanner} alt="App" />
                    </picture>
                </div>
                <div className="appsEmDestaque-itens-ButtonContainer">
                    <p>
                        <Link to={this.urlWhithLang(app[0].locationId, this.state.lang)}>{texts["mais-informações"][this.state.lang]}</Link>
                    </p>
                </div>
            </section>
        );
    }
}

export default AppsEmDestaqueItem;



// WEBPACK FOOTER //
// ./src/componentes/AppsEmDestaqueItem.js